// extracted by mini-css-extract-plugin
export default {"knowAbout":"KnowAbout_knowAbout__AoHdl","knowAbout__ul":"KnowAbout_knowAbout__ul__FBQrz","knowAbout__ul__li":"KnowAbout_knowAbout__ul__li__lZ+9B"};